<template lang="html">
  <div class="player-card">
    <div class="image" v-if="player">
      <player-image :player="player" />

      <div class="info">
        <div class="name">
          <span>
            {{ player.position }} {{ player.name }}
          </span>

          <b class="primary-color" v-if="player.keeper">
            K
          </b>
        </div>
        <div>{{ player.team }}</div>
        <div>
          <span>Round {{ player.round }} - Pick {{ player.pick }}</span>
        </div>
      </div>
    </div>

    <div class="empty" v-else />
  </div>
</template>

<script>
import PlayerImage from '@/components/PlayerImage';

export default {
  props: {
    player: Object,
  },

  components: {
    PlayerImage,
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .player-card {
    margin: $gp 0;
    color: $black-color;

    display: flex;
    flex-direction: column;
    align-items: center;
    width: px-to-rem(180px);

    .image {
      position: relative;
      width: 100%;
    }

    .info {
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      color: $white-color;
      padding: $gp / 2;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      font-size: px-to-rem(14px);
    }

    .name {
      font-weight: $font-weight-bold;
    }

    .empty {
      background-color: $dark-color-active;
      height: px-to-rem(112px);
      width: 100%;
    }
  }
</style>
